export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';
export const ACCOUNT_CONFIRMATION_SUCCESS = 'ACCOUNT_CONFIRMATION_SUCCESS';
export const SET_PASSWORD_SUCCCESS = 'SET_PASSWORD_SUCCCESS';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const PASSWORD_RESET_SENT = 'PASSWORD_RESET_SENT';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const SET_SELECTED_MERCHANT = 'SET_SELECTED_MERCHANT';
export const CLEAR_SELECTED_MERCHANT = 'CLEAR_SELECTED_MERCHANT';


// WEBPACK FOOTER //
// ./app/auth/constants/authConstants.js